<script lang="ts" setup>
	const OVER_ALL_RATING = 5
	const props = withDefaults(defineProps<{ rating?: number }>(), {
		rating: 0
	})
	const ratingStar = Array.from({ length: OVER_ALL_RATING }, (_, index) => index + 1).map(item => {
		return {
			icon: 'rating-star',
			dir: props.rating > item ? 'fill' : 'line'
		}
	})
</script>

<template>
	<div>
		<tools-icon
			v-for="(item, index) in ratingStar"
			:key="index"
			:icon="item.icon"
			:dir="item.dir"
			:width="11.668"
			:height="11.5723"
		/>
	</div>
</template>
